<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    links: Array,
});
</script>

<template>
    <div class="mt-20 flex flex-wrap items-center gap-2">
        <Component
            :is="link.url ? Link : 'span'"
            v-for="link in links"
            :key="link.id"
            :href="link.url"
            class="hover:bg-olive flex h-[40px] w-[auto] min-w-[40px] items-center justify-center rounded px-3 text-base leading-4 transition-colors duration-300 hover:text-black"
            :class="{
                'hover:bg-beige-dark hover:text-green opacity-40': !link.url,
                'bg-primary text-white': link.active,
                'bg-gray-light text-black': !link.active,
            }"
            v-html="link.label"
        />
    </div>
</template>
